// eslint-disable-next-line no-shadow
export enum PaymentMethodEnum {
  CreditCard = 'credit_card',
  Pix = 'pix',
}
